<template>
	<div class="the-header">
		<!-- <SideNavToggle @toggle="$emit('SideNavToggle') " /> -->
		<div class="logo-container">
				<router-link to="/" exact=""><div class="inner" /></router-link>
		</div>
		<div class="menu-container">
			<ul class="nav-list">
				<li>
				<router-link v-scroll-to="'#collection'" to="/" exact="">
					{{ currentLanguage.menu.collection }}
				</router-link>
				</li>
				<li v-scroll-to="'#homeSearch'">
					<router-link to="/search" exact="">
						{{ currentLanguage.menu.search }}
					</router-link>
				</li>
				<li>
					<router-link to="/contact" exact="">
						{{ currentLanguage.menu.contact }}
					</router-link>
				</li>
			</ul>
		</div>
		<div class="language-switcher">
			<div class="dropdown" @click="toggleDropdown">
				<button class="dropdown-btn">
				<img :src="currentLanguageFlag" alt="Language Flag" class="language-flag" />
				{{ currentLanguageName }}
				<span class="dropdown-arrow" :class="showDropdown ? 'dropdown-arrow-up' : 'dropdown-arrow-down'">
					&#9662;
					</span>
				</button>
				<div v-show="showDropdown" class="dropdown-content">
				<a @click="changeLanguage('en')" href="#">
					<img src="@/assets/img/US.svg" alt="English Flag" class="language-flag" /> EN
				</a>
				<a @click="changeLanguage('el')" href="#">
					<img src="@/assets/img/GR.svg" alt="Greek Flag" class="language-flag" /> EL
				</a>
				</div>
			</div>
		</div>
		<div v-if="false" class="search-container">
			<!-- <input class="simple-input" type="text" placeholder="ΑΝΑΖΗΤΗΣΗ" />
			<md-icon style="color:rgba(0, 0, 0, 0.85)">search</md-icon> -->
			<md-field md-clearable>
				<label>ΑΝΑΖΗΤΗΣΗ</label>
				<md-input placeholder=""></md-input>
			</md-field>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: "AppHeader",
	data() {
		return {
			showDropdown: false
		}
	},
	components: {
	},
	computed: {
		...mapGetters(['currentLanguage']),
		currentLanguageName() {
			return this.currentLanguage.code || 'EN'
		},
		currentLanguageFlag() {
			return this.currentLanguage.flag || require('@/assets/img/US.svg')
		}
	},
	methods: {
		...mapActions(['changeLanguage']),
		toggleDropdown() {
			this.showDropdown = !this.showDropdown
		}
	}
}
</script>

<style scoped lang="scss">

	.the-header {
		display: flex;
		padding: 10px 20px;
		width: 100%;
		justify-content: space-around;

		ul {
			display: flex;
			list-style: none;
			max-width: 90%;
			min-width: 80%;

			a {
				white-space: nowrap;
			}
		}

	}

	.logo-container .inner {
		background-image: url("../../assets/img/logo.png");
		background-repeat: no-repeat;
		background-size: contain !important;
		padding: 10%;
		width: 26rem;
		z-index: 1;
		background-position-x: center;
	}

	.menu-container {
		display: flex;
		flex-grow: 1;
		flex-direction: column;
		align-items: flex-end;
	}

	.search-container {
		margin: auto;
		flex-grow: 1;
		justify-self: flex-end;
		justify-content: center;
    display: flex;

		.md-field {
			width: 33%;
		}

		.md-field.md-theme-default.md-has-value .md-input {
			-webkit-text-fill-color: #000;
		}

		.md-field.md-theme-default.md-focused label {
			color: #000;
		}

		.md-field.md-theme-default:after {
			background-color: $grey;
		}

		input:focus {
			color: $orange;
			border-color: $grey;
			outline-width: 0px;
		}

	}

	.nav-list {
		margin: auto 5% auto 0;
		padding: 0;
		width: 60%;
		justify-content: flex-end;

		li {
			font-size: 20px;
			font-size: calc(12px + (18 - 12) * ((100vw - 300px) / (1600 - 300)));
			margin: 0 2%;
			// margin-left: 3%;
		}
	}
@media (max-width: 1450px) {

	.logo-container .inner {
		width: 20rem
	}

	.nav-list {
		width: 100%;

		li {
				font-size: 17px;
			}
	}

	.search-container input {
		height: 38px;
	}
}

@media (max-width: 1200px) {
	.logo-container .inner {
		width: 14rem
	}

}
</style>
